import { ConfirmationDialog, useDialog } from '@axellero/shared';
import type { ReactElement } from 'react';
import { useCallback, useState } from 'react';
import { useMutation } from 'urql';

import { mutationRemoveNodeInput } from '../model/mutationRemoveNodeInput.gql';
import type {
  RemoveNodeInputMutation,
  RemoveNodeInputMutationVariables,
} from '../model/mutationRemoveNodeInput.gql.gen';

export const useRemoveNodeInput = (): [
  element: ReactElement,
  start: (nodeId: string, paramId: string) => void
] => {
  const [{ fetching }, removeNode] = useMutation<
    RemoveNodeInputMutation,
    RemoveNodeInputMutationVariables
  >(mutationRemoveNodeInput);

  const [dialogProps, setDialogOpen] = useDialog();

  const [nodeId, setNodeId] = useState('');
  const [nodeParamId, setNodeParamId] = useState('');

  const handleStart = useCallback(
    (id: string, paramId: string) => {
      setNodeId(id);
      setNodeParamId(paramId);
      setDialogOpen(true);
    },
    [setDialogOpen]
  );
  const handleReset = useCallback(() => {
    setNodeId('');
    setNodeParamId('');
    setDialogOpen(false);
  }, [setDialogOpen]);

  const handleSubmit = useCallback(() => {
    removeNode({ nodeId, nodeParamId }).then(() => {
      handleReset();
    });
  }, [handleReset, nodeId, nodeParamId, removeNode]);

  return [
    <ConfirmationDialog
      key="remove-node-input"
      title="Remove input parameter node?"
      {...dialogProps}
      loading={fetching}
      onReset={handleReset}
      onSubmit={handleSubmit}
    />,
    handleStart,
  ];
};
